import { ISelect } from "../model/iSelect";
import { ILocality } from "../model/locality.model";

export const locatitiesOptions = (
  localities: ILocality[] | any
): Array<ISelect> => {
  const options: Array<ISelect> = localities
    ? localities.map((locality: ILocality) => ({
        value: locality.id,
        label: locality.name,
      }))
    : null;

  return options;
};

export const localitiesOptionsByProvince = (
  localities: ILocality[] | any,
  provinceId: number
): Array<ILocality> => {
  const options: Array<ILocality> = localities
    ? localities.filter((loc: ILocality) => loc?.province?.id === provinceId)
    : [];
  return options;
};
